import React, { useState } from "react"
import api from "../services/axiosInterceptor.js";
import { useAuth } from "../context/AuthContext"
import { useNavigate, redirect, useLocation, Link } from "react-router-dom"
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import PostData from "../services/PostData";
import SnackbarEx from "../components/Helpers/SnackbarEx";
import Bread_Bskt from "../images/Bread_Bskt.png"
// import GoogleSignIn from "./GoogleAuth";


function Authorization() {
    const { login: contextLogin } = useAuth();
    const [emailInput, setEmailInput] = useState("")
    const [passInput, setPassInput] = useState("")

    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false
    })

    const [load, setLoad] = useState(false)
    const [loggingIn, setLoggingIn] = useState(false)
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const apiLink = 'api/login/rushs-payroll'

    const navigate = useNavigate()

    const getRedirectPath = (role) => {
        // Check for redirect param first
        const redirectParam = params.get("redirect");
        if (redirectParam) return redirectParam;

        // Default redirects based on role
        if (role === "GlobalAdmin" || role === "AppAdmin") {
            return "/time-sheet-landing";
        }
        return "/time-sheet-landing";
    };

    /*-----------------------Handle Login--------------------------*/
    /*
    async function handleLogin(event) {
        setLoggingIn(true)
        event.preventDefault()
        try {
            const { success, error: loginError, usr, db, role, token } = await PostData(
                {
                    "email": emailInput,
                    "password": passInput
                }, apiLink, true)
            setLoad(true)

            if (success && (role === "AnalyticsOnly")) {
                // sessionStorage.setItem("urtkn", token)
                setLoad(false)
                setLoggingIn(false)
                login(true, db, usr, role)
                const redirectTo = params.get("redirect") || "/invoice-file-upload";
                navigate(redirectTo, { replace: true });
            }
            else if (success && (role === "GlobalAdmin" || role === "AppAdmin")) {
                setLoad(false)
                setLoggingIn(false)
                login(true, db, usr, role)

                const redirectTo = params.get("redirect") || "/invoice-file-upload";
                navigate(redirectTo, { replace: true });

            } else if (success && (role === "User")) {
                setLoad(false)
                setLoggingIn(false)
                login(true, db, usr, role)
                const redirectTo = params.get("redirect") || "/invoice-file-upload";
                navigate(redirectTo, { replace: true });
            }
            else {
                setLoad(false)
                setLoggingIn(false)
                // setEmailInput("")
                setPassInput("")
                if (loginError) {
                    setOpenTestSnack({ color: "error", message: loginError?.response?.data?.error, open: true })
                }

                redirect("/login")
            }
        } catch (error) {
            console.error(error)
            redirect("/login")
        }
    }

    const handleGoogleSignIn = async (idToken) => {
        setLoad(true)

        const { success, error: loginError, usr, role, db } = await PostData({ "credential": idToken }, "api/login/analytics-google", true)
        console.log('Success:', success, "ROLE : ", role)
        if (success) {
            // sessionStorage.setItem("urtkn", token) // You might want to handle token storage within AuthContext's login
            setLoad(false)
            setLoggingIn(false)
            login(true, db, usr, role)
            const redirectTo = params.get("redirect") || "/invoice-file-upload";
            navigate(redirectTo, { replace: true });
        } else {
            setLoad(false)
            setLoggingIn(false)
            setPassInput("") // Only clear password on error
            if (loginError) {
                setOpenTestSnack({ color: "error", message: loginError?.response?.data?.error, open: true })
            }
            // No need to router.push("/login") as we are already on the login page
        }
    }
        */

    async function handleLogin(event) {
        event.preventDefault()
        setLoggingIn(true)
        try {
            const { success, error: loginError, usr, role, token } = await PostData(
                {
                    "email": emailInput,
                    "password": passInput
                }, apiLink, true)
            if (!success) {
                throw new Error(loginError || "Login failed during API call.");
            }
            const loginResult = await contextLogin(usr, role);

            if (loginResult.success) {
                setLoggingIn(false)
                const redirectPath = getRedirectPath(role);
                navigate(redirectPath, { replace: true });
            } else {
                throw new Error(loginResult.error || "Login failed");
            }
        } catch (error) {
            console.error("Login error:", error);
            setPassInput("");
            setOpenTestSnack({
                color: "error",
                message: error?.response?.data?.message || "An error has occurred.",
                open: true
            });
        } finally {
            setLoggingIn(false);
        }
    }

    // const handleGoogleSignIn = async (idToken) => {
    //     setLoad(true)
    //     const { success, error: loginError, usr, role, db } = await PostData({ "credential": idToken }, "api/login/analytics-google", true)
    //     const loginResult = await contextLogin(usr, role);
    //     if (loginResult.success) {
    //         const redirectPath = getRedirectPath(role);
    //         navigate(redirectPath, { replace: true });
    //     } else {
    //         throw new Error(loginResult.error || "Login failed");
    //     }
    // }


    /*-----------------------Render--------------------------*/
    if (load) {
        return (<div className="pg-spin" style={{ position: 'relative', top: '50%' }}><CircularProgress /></div>)
    }
    return (
        <>

            <div className="row" >
                <div className="col-12">
                    <div className="row justify-content-center align-items-center" style={{ height: "75vh" }}>

                        <div className="col-xl-4 col-md-10">
                            <div className="row justify-content-center align-items-center" style={{ padding: "20px 15px 0 15px" }}  >
                                <div className="col-6 mx-auto" style={{ width: '200px', marginBottom: '20px' }}>
                                    <img src={Bread_Bskt} style={{ width: '115px', height: '110px', marginLeft: '32px' }} />
                                </div>
                            </div>

                            {/*---------------- -------- -------- --------UNDER LOGO SECTION -------- -------- -------- --------  */}
                            <div className="row rst-pss"  >

                                <div className="col-12 login-container">
                                    <div className='row' style={{ padding: "20px 15px 0 15px" }}>
                                        <p style={{ fontSize: '30px', height: '30px' }}>Welcome Back! </p>
                                        <hr style={{ borderWidth: '0.5px' }} />
                                    </div>


                                    <form className="login-form" onSubmit={handleLogin}>

                                        <div className="row" style={{ width: '100%', paddingLeft: '20px', paddingBottom: "25px" }} >

                                            <TextField size="small" name="email" type="text" label="Email" required
                                                onChange={(e) => setEmailInput(e.target.value)} value={emailInput}
                                            />

                                        </div>
                                        <div className="row" style={{ width: '100%', paddingLeft: '20px', paddingBottom: "25px" }} >

                                            <TextField size="small" name="password" type="password" label="Password" required
                                                onChange={(e) => setPassInput(e.target.value)} value={passInput}
                                            />

                                        </div>

                                        <div className="row" style={{ width: "100%", padding: "0 10px", marginBottom: "15px" }} >

                                            <button className="submit" type="submit">
                                                {loggingIn ? <CircularProgress size={20} sx={{ color: 'white' }} /> : "Login"} </button>

                                        </div>
                                        {/* <div className="row" style={{ width: "55%", padding: "0 10px", marginBottom: "15px", justifyContent: "center" }}>
                                            <GoogleSignIn googCredentials={(googCreds) => handleGoogleSignIn(googCreds)} />
                                        </div> */}
                                    </form>

                                    <div className="row" style={{ paddingLeft: '15px', width: '200px', paddingBottom: '20px' }}>
                                        <Link to={"/reset-password"} style={{ textDecoration: 'none', fontSize: 'small' }}>Forgot Password?</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >
            {
                openTestSnack.open && <SnackbarEx
                    color={openTestSnack.color}
                    position="top"
                    message={openTestSnack.message}
                    open={openTestSnack.open}
                    close={() => setOpenTestSnack({
                        color: "",
                        message: "",
                        open: false
                    })} />
            }
        </>
    )
}

export default Authorization
